<template>
  <!-- d2-container 文档 https://doc.d2admin.fairyever.com/zh/sys-components/container.html -->
  <d2-container :filename="filename">
    <el-card style="margin-bottom: 5px">
      <demo-page-header @submit="handleSubmit" @detailPrinting="detailPrinting" @exportExcel="exportExcel"
        ref="header" />
    </el-card>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card shadow="always" :body-style="{ padding: '20px' }">
          <div slot="header" class="clearfix">
            <span>空调摊派账单</span>
            <span style="width:100px;float:right">
            </span>
          </div>
          <el-col>
            <el-row style="padding-bottom: 20px;">
              <table-page-main ref="acFeeDetailsTable" :table-data="BuildTable" :loading="loading"
                :search-form="searchForm" @deleteDateSuccess="addDateSuccess" @dateSuccess="addDateSuccess"
                @handleSubmit="handleSubmit" />
            </el-row>
            <el-row style="padding-bottom: 20px;">
              <demo-page-footer :current="page.current" :size="page.size" :total="page.total"
                @change="handlePaginationChange" />
            </el-row>
          </el-col>
        </el-card>
      </el-col>
    </el-row>
  </d2-container>
</template>

<script>
// 组件
import * as qs from "qs";
import { queryAcFeeDetailsAllByLimit } from "@/api/AcFeeDetailsImport";

var _ = require('lodash')
// 请删除下面代码中你不需要的部分
export default {
  name: 'AcFeeDetailsTable',
  components: {
    'DemoPageHeader': () => import('./components/PageHeader/index.vue'),
    'TablePageMain': () => import('./components/AcFeeDetailsTable'),
    'DemoPageFooter': () => import('./components/PageFooter/index.vue')
  },
  // 数据
  data() {
    return {
      filename: __filename,
      BuildTable: [],
      loading: false,
      searchForm: {},
      page: {
        current: 1,
        size: 12,
        total: 0
      }
    }
  },
  mounted() {
    this.$refs.header.handleFormSubmit(false)
  },
  // 事件处理方法
  methods: {
    addDateSuccess() {
      this.$refs.header.handleFormSubmit(false)
    },
    // 分页
    handlePaginationChange(val) {
      this.page = {
        current: val.current,
        size: val.size,
        total: val.total
      }
      // nextTick 只是为了优化示例中 notify 的显示
      this.$nextTick(() => {
        this.$refs.header.handleFormSubmit(false)
      })
    },
    // 查询
    handleSubmit(form, val) {
      this.loading = true
      let obj = _.pickBy(form, _.identity)
      _.unset(obj, 'onOrOff')
      if (val) {
        this.page.current = 1
      }
      obj.executionStatus = 1
      obj.current = this.page.current
      obj.size = this.page.size
      // 保存查询条件用于子组件详情查询
      this.searchForm = { startDate: form.startDate, endDate: form.endDate }
      queryAcFeeDetailsAllByLimit(obj)
        .then(res => {
          this.loading = false
          this.BuildTable = res.records
          this.page.total = res.total
        })
        .catch(err => {
          this.loading = false
          this.$notify({
            title: '数据请求异常'
          })
          console.log('err', err)
        })
    },
    detailPrinting() {
      this.$refs.acFeeDetailsTable.selectedObjects()
    },
    // 导出 Excel
    exportExcel(form) {
      const columns = [
        { label: '执行状态', prop: 'executionStatus' },
        { label: '系统房间', prop: 'roomCode' },
        { label: '空调房间', prop: 'acUnitNumber' },
        { label: '空调机组', prop: 'rcUnit' },
        { label: '楼层', prop: 'floor' },
        { label: '运转时间[h]', prop: 'runTimeHours' },
        { label: '电量[kWh]', prop: 'electricityKwh' },
        { label: '费用[人民币]', prop: 'feeRmb' },
        { label: '含税费用[人民币]', prop: 'taxFeeRmb' },
        { label: '开始日期', prop: 'startDate' },
        { label: '结束日期', prop: 'endDate' },
        { label: '操作时间', prop: 'settlementTime' }
      ]

      let obj = _.pickBy(form, _.identity)
      obj.executionStatus = 1
      obj.current = 1
      obj.size = 100000

      this.loading = true
      queryAcFeeDetailsAllByLimit(obj)
        .then(res => {
          this.loading = false
          // 格式化数据，保证会计精度
          const formatNum = (val, decimals = 2) => {
            if (val === null || val === undefined) return '0.00'
            return Number(val).toFixed(decimals)
          }
          const data = res.records.map(item => {
            return {
              executionStatus: item.executionStatus === 0 ? '待结算' : item.executionStatus === 1 ? '已结算' : '已作废',
              roomCode: item.roomCode,
              acUnitNumber: item.acUnitNumber,
              rcUnit: item.rcUnit,
              floor: item.floor,
              runTimeHours: formatNum(item.runTimeHours, 2),
              electricityKwh: formatNum(item.electricityKwh, 2),
              feeRmb: formatNum(item.feeRmb, 2),
              taxFeeRmb: formatNum(item.taxFeeRmb, 2),
              startDate: item.startDate,
              endDate: item.endDate,
              settlementTime: item.settlementTime
            }
          })

          const dateRange = form.startDate && form.endDate ? `${form.startDate} 至 ${form.endDate}` : '全部'
          this.$export.excel({
            columns,
            data,
            title: '空调摊派账单',
            header: `空调摊派账单 (${dateRange})`,
            merges: ['A1', 'L1']
          })
        })
        .catch(err => {
          this.loading = false
          this.$notify({
            title: '导出失败'
          })
          console.log('err', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'AcFeeDetailsTable';
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/TongJiFenXi/AcFeeDetailsTable/AcFeeDetailsTable.vue"
}
</vue-filename-injector>
